import DOMPurify from "dompurify";

/**
 * Säuberung des gespeicherten Berichts-Markups.
 *
 * Das von Hand bearbeitete Markup wird serverseitig **ungereinigt** abgelegt
 * (bewusst — im Backend gibt es keinen HTML-Sanitizer, und ein selbstgebauter
 * Filter wäre die schlechtere Absicherung als DOMPurify an der Ausgabe; s.
 * `statusReports.service.ts::saveEditedReport` und TK §12.5). Dieser Aufruf
 * ist damit die **einzige** Absicherung des gespeicherten Markups: Der Bericht
 * wird auch anderen Nutzern gezeigt, ein hinterlegtes `<script>` liefe also im
 * Browser eines Kollegen.
 *
 * Als eigene Funktion herausgezogen, damit genau diese Eigenschaft einen Test
 * bekommt — ein versehentliches Entfernen des Aufrufs fiele sonst niemandem
 * auf (Befund W9/W11).
 */
export function sanitizeReportHtml(html: string): string {
  return DOMPurify.sanitize(html);
}
